import {createContext} from 'react';
export const LocalPlayerContext = createContext(null);
